import React, { Component } from 'react';
import { connect } from 'react-redux';
import IgniteDataTable from '../../common/datatable';
import { destandard, ucfirst } from '../../../utils/commonFunctions';

class StaffMemberList extends Component {
  constructor(props) {
    super(props);

    const { rowClick } = props;

    this.outletColumns = [
      {
        prop: 'id',
        title: 'ID',
        width: '100',
        onClick: rowClick,
      },
      {
        prop: 'name',
        title: 'Name'
      },
      {
        prop: 'status',
        title: 'Status'
      },
      {
        prop: 'user_group',
        title: 'User Group',
        format(data) {
          return (
            <b>
              {data.name || (ucfirst(data.toString()))}
            </b>
          );
        }
      },
      {
        prop: 'registration_date',
        title: 'Registration Date'
      },
    ];
  }

  render() {
    const { owner, staffMembers } = this.props;

    if (owner && owner.id) {
      staffMembers.push(destandard(owner));
    }

    return (
      <div>
        <IgniteDataTable
          columns={this.outletColumns}
          data={staffMembers}
          hasAttributes={false}
        />
      </div>
    );
  }
}

export default connect()(StaffMemberList);



// WEBPACK FOOTER //
// ./src/components/common/outlet/staff-member-list.jsx